export const isBookClubReading = (reading) => !!reading?.bookClubId;

export const isReadingTrackingReadOnly = (reading, isPremium = false) =>
  !isPremium && !isBookClubReading(reading) && !!reading?.paywall?.isReadOnly;
